// @ts-strict-ignore
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';

export class SelectedArticlesReferenceArticleLocationVO extends ArticleLocationVO {
  public articleContainers: ArticleContainer[];

  public constructor() {
    super();
  }
}
